export const Constants = {
  RM_OTP_SENT: "Access code has been sent to your email",
  EM_OTP_INCORRECT: "Access code entered is incorrect",
  EVENT_CLICKAWAY: "clickaway",

  PHONE_COUNTRY_CODE: "+91",

  FONT_SIZE_MEDIUM: "medium",
  FONT_SIZE_LARGE: "large",
  FONT_SIZE_SMALL: "small",

  SYMBOL_QUESTION: "?",
  SYMBOL_FORWARDSLASH: "/",
  SYMBOL_EQUAL: "=",
  SYMBOL_AMPERSAND: "&",
  STATUS_OK: "OK",

  HEADING_TEXT_LOGIN: "Login",
  HEADING_TEXT_HOME: "Dashboard",
  TEXT_FILES: "Files",
  HEADING_TEXT_LIST_USER: "User Profile",
  HEADING_TEXT_EDIT_USER: "Edit User",
  HEADING_TEXT_VIEW_USER: "Profile Details",
  HEADING_TEXT_LIST_GALLERY: "Gallery",
  HEADING_TEXT_VIEW_GALLERY: "Cinc Details",
  HEADING_TEXT_VIEW_ASSETS: "Assets",
  HEADING_TEXT_VIEW_SPACE_CONSUMED: "Space Consumed",

  HEADING_TEXT_LIST_EVENT: "Cinc",
  HEADING_TEXT_EDIT_EVENT: "Edit Cinc",
  URL_PARAMETER_TEXT_PAGE: "page",
  HEADING_TEXT_VIEW_EVENT: "Cinc Details",

  HEADING_TEXT_LIST_REPORT: "Tickets",
  HEADING_TEXT_LIST_REPORT_ISSUE: "Report Issue",
  TEXT_STATUS_ACTIVE: "Active",
  TEXT_STATUS_DEACTIVE: "Deactive",
  TEXT_JOINED_DATE: "Joined Date",
  TEXT_STATUS_RESOLVED: "Resolved",
  TEXT_STATUS_PENDING: "Pending",
  TEXT_STATUS_PROGRESS: "In progress",
  TEXT_GEOCODE_FAILED: "Geocode was not successful for the following reason:",
  // CENTER: "center",

  HEADING_TEXT_USER_SETTINGS: "User Information",
  TEXT_LOADING: "Loading...",
  TEXT_NO_RECORDS: "No records found",
  TEXT_LTR: "ltr",
  TEXT_LOGOUT: "Logout",
  TEXT_HOME: "Home",
  TEXT_USER: "User",
  TEXT_EVENT: "Cinc",
  TEXT_ACTIONS: "Actions",
  TEXT_SAMPLE:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum .Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  TEXT_EVENT_ID: "Event Id",
  TEXT_EVENT_NAME: "Cinc Name",
  TEXT_CREATED_BY: "Cinc Created By",
  TEXT_CREATED_DATE: "Creation date",
  TEXT_START_DATE: "Cinc Start Date",
  TEXT_EVENT_STATUS: "Cinc Status",
  TEXT_EVENT_PAID_STATUS: "Cinc Paid Status",
  TEXT_EVENT_INVITES: "Cinc Total Invite",
  TEXT_RECORDED_DATE: "Recorded date",
  TEXT_EVENT_FULL_LOCATION: "Event Full Location",
  TEXT_EVENT_DATE_AND_TIME: "Event Date and Time",
  TEXT_USER_NAME: "User Name",
  TEXT_EMPTY: " ",
  TITLE_EVENT_DELETE: "Delete Cinc",
  TITLE_EVENT_DELETE_PARTICIPANT: "Remove Participant",
  TITLE_USER_DELETE: "Delete Profile",
  TITLE_DELETE_IMAGE: "Delete Image",
  TITLE_DELETE_MEDIA: "Delete Media",
  DELETE_WARNING: "Are You Sure Want To Delete ",
  FILE_DELETE: "File deleted successfully.",
  EVENT_DELETE_MESSAGE:
    "You can't delete this event as it has transactions associated with it",
  SESSION_MESSAGE: "Session Expired",
  ERROR_MESSAGE: "Something went wrong !!",
  PASSWORD_VALUE: "********",
  TEXT_ACCOUNT_SETTINGS: "Account Settings",
  TEXT_RESEND_CODE: "Resend Code",
  TEXT_BELOW_LOGO: "Welcome Back !",
  TEXT_BELOW_LOGO_IN_LOGIN: "Login to your Admin Account",
  TEXT_ACCESS_CODE: "Access Code",
  TEXT_EMAIL: "Email",
  TEXT_PASSWORD: "Password",
  TEXT_BEARER: "Bearer",
  TEXT_TOKEN: "Token",
  TEXT_REMEMBER_ME: "Remember me",
  TEXT_CATEGORY_NONE: "None",
  URL_PARAMETER_PAGE: "page",
  URL_PARAMETER_PAGE_SIZE: "page_size",
  RECORDS_PER_PAGE: "Records per page",
  LOAD_MORE: "Load More...",
  UNKNOWN_LOCATION: "Location Unknown",

  BUTTON_HEADING_TEXT_LOGIN: "Log In",
  BUTTON_TEXT_SENT_OTP: "Send OTP",
  BUTTON_TEXT_BACK: "Back",
  BUTTON_TEXT_SEARCH: "Search",
  BUTTON_TEXT_SAVE: "Save",
  BUTTON_TEXT_CANCEL: "Cancel",
  BUTTON_TEXT_YES: "Yes",
  BUTTON_TEXT_NO: "No",
  BUTTON_TEXT_CLEAR: "Clear",
  BUTTON_TEXT_DELETE: "Delete Account",
  BUTTON_TEXT_DEACTIVATE: "Deactivate",
  BUTTON_HEADING_TEXT_VERIFY: "Verify",

  LOCAL_STORAGE_KEY_ID_TOKEN: "idToken",
  LOCAL_STORAGE_EVENT: "storage",
  LOCAL_STORAGE_KEY_USER: "user",
  LOCAL_STORAGE_KEY_REPORT: "report",
  LOCAL_STORAGE_KEY_EVENT: "event",
  LOCAL_STORAGE_KEY_ADMIN_USER: "adminUser",
  LOCAL_STORAGE_KEY_REMEMBER_ME: "rememberme",
  MEDIA_TYPE_VIDEO: "video",
  MEDIA_TYPE_IMAGE: "image",

  TABLE_USER_HEADER_LIST: [
    "Profile",
    "Full Name",
    "Username",
    "Email",
    "Phone",
    "Phone",
    "Actions",
  ],
  USER_DETAIL_HEADER_LIST: [
    "User Name",
    "Notification",
    "Email",
    "Phone",
    "Change Password",
    "Date Of Birth",
    "Location",
  ],

  VIEW_EDIT_REPORT_ISSUE_HEADER_LIST: [
    "Ticket ID",
    "Ticket Subject",
    "Description",
    "Files",
    "Report Status",
    "Notes",
  ],

  TEXT_USER_FIRST_NAME: "Full Name",
  TEXT_USER_EMAIL: "Email",
  TEXT_USER_PHONE: "Phone",
  TEXT_USER_USERNAME: "Username",
  TEXT_USER_STATUS: "Status",
  TEXT_USER_PROFILE: "Profile",
  PAGE_SIZE_ARRAY: [10, 20],
  DATE_FORMAT_DD_MM_YYYY: "DD-MM-YYYY",
  DATE_FORMAT_YYYY_MM_DD: "YYYY-MM-DD",
  DATE_FORMAT_MM_DD: "-12-31",
  DATE_TIME_FORMAT: "dd/MM/yyyy hh:mm a",
  REPORT_DATE_TIME_FORMAT: "MM/DD/YYYY",
  SCHEDULED_DATE_TIME_FORMAT: "DD MMMM YYYY",
  CINC_INPUT_DATE_TIME_FORMAT: "MMMM DD, YYYY",
  DOB_FORMAT: "MMMM DD, YYYY",

  COLOR_BLACK: "black",
  COLOR_PRIMARY: "#7CCAB3",
  COLOR_INFO: "info",
  COLOR_WARNING: "warning",
  COLOR_TEXT_PRIMARY: "textPrimary",
  COLOR_SUCCESS: "#28C400",

  VARIANT_OUTLINED: "outlined",
  VARIANT_CONTAINED: "contained",
  VARIANT_TEXT: "text",

  NUMBER_ONE: 1,
  NUMBER_TEN: 10,
  NUMBER_RESEND_CODE_TIMER_60: 30,

  DASHBOARD_ACTIVE_USERS: "Active Users",
  DASHBOARD_ACCOUNT_CREATED: "Account Created",
  DASHBOARD_BUBBLES_CREATED: "Bubble Created",
  DASHBOARD_TRANSACTION: "Transaction",
  DASHBOARD_CINC_CREATED: "Cinc Created",
  DASHBOARD_CINC_ACCEPTED: "Cinc Accepted",
  DASHBOARD_CINC_DECLINED: "Cinc Declined",
  DASHBOARD_CINC_NEVER_ANSWER: "Cinc Never Answer",
  MAP_KEY: "AIzaSyCcQr3CmrbS9TMv0iXausvR2jsxU7xuy7U",
};
export const FormValues = {
  FORM_USER_INPUT_NAME_FIRSTNAME: "full_name",
  FORM_USER_INPUT_NAME_USERNAME: "username",
  FORM_USER_INPUT_NAME_PHONE: "phone_number",
  FORM_USER_INPUT_NAME_EMAIL: "email",
  FORM_USER_INPUT_NAME_BIRTH: "date_of_birth",
  FORM_USER_INPUT_NAME_ADDRESS: "address",
  FORM_USER_INPUT_NAME_SEARCH: "search",
  FORM_USER_INPUT_NAME_USERNAME: "username",
  FORM_USER_INPUT_iMAGE: "image_url",
  FORM_STATUS_ACTIVE: "is_active",
  FORM_USER_INPUT_TYPE_PHONE: "phone",
  FORM_EVENT_INPUT_NAME_IMAGE: "event_image",
  FORM_EVENT_INPUT_NAME_NAME: "name",
  FORM_EVENT_INPUT_NAME_SCHEDULED_TIME: "scheduled_time",
  FORM_EVENT_INPUT_NAME_SEARCH: "search",
  FORM_EVENT_INPUT_START_DATE: "start_date",
  FORM_EVENT_INPUT_START_TIME: "start_time",
  FORM_EVENT_INPUT_END_DATE: "end_date",
  FORM_EVENT_INPUT_END_TIME: "end_time",
  FORM_EVENT_INPUT_EXPIRE_DATE: "expire_date",
  FORM_EVENT_INPUT_EXPIRE_TIME: "expire_time",
  FORM_EVENT_INPUT_AVAILABILITY: "cinc_availability",
  FORM_EVENT_INPUT_CATEGORY: "category",
  FORM_EVENT_INPUT_PAID_STATUS: "paid_status",
  FORM_EVENT_INPUT_IS_PAID: "is_paid",
  FORM_EVENT_INPUT_LOCATION: "full_location",
  FORM_EVENT_INPUT_LATITUDE: "latitude",
  FORM_EVENT_INPUT_LONGITUDE: "longitude",
  FORM_EVENT_INPUT_PARTICIPANT_LIST: "participant_list",
  FORM_EVENT_INPUT_STATUS: "event_status",
  FORM_EVENT_INPUT_SIZE: "cinc_invitee_count",
  FORM_ISSUE_TICKET_ID: "ticket_id",
  FORM_ISSUE_ISSUE: "issue",
  FORM_ISSUE_DESCRIPTION: "description",
  FORM_ISSUE_NOTES: "notes",
  FORM_ISSUE_CREATED: "created_at",

  FORM_LOGIN_INPUT_NAME_EMAIL: "email",
  FORM_LOGIN_INPUT_NAME_PASSWORD: "password",
  FORM_LOGIN_INPUT_NAME_USER_UUID: "user_uuid",
  FORM_LOGIN_INPUT_NAME_EMAIL_OTP: "email_otp",
  FORM_LOCATION_INPUT_NAME_SEARCH: "search",
  FORM_GROUP_INPUT_NAME_NAME: "name",
  FORM_GROUP_INPUT_NAME_SEARCH: "search",
  FORM_GROUP_INPUT_ASSETS: "assets",
  FORM_GROUP_INPUT_SPACE_CONSUMED: "space_consumed",
};

export const USER_STATUS = [
  {
    id: "1",
    label: "All User",
    value: "all",
  },
  {
    id: "2",
    label: "Deactivated User",
    value: "Deactivated",
  },
  {
    id: "3",
    label: "Deleted User",
    value: "Deleted",
  },
];

export const COUNTRY_CODES = [
  {
    code: "US",
    label: "United States",
    phone: "+1",
  },
];
